import { useContext } from 'react';
import { CollabsContext } from '../contexts/collabs_context';

const useCollabsContext = () => {
    return useContext(CollabsContext);
};

export default useCollabsContext;
